const delivery = [
  {
    path: '/delivery-settings',
    name: 'delivery.settings',
    component: () => import('@/views/delivery/ProductDeliverySettings'),
    meta: {
      env:['production'],
      pageTitle: 'Configurações',
      roles: [1, 2, 5],
      breadcrumb: [
        {
          text: 'Restrições de Entrega Local',
          active: true,
        },
      ],
    },
  },
]

export default delivery
